import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface ICustomerFormData {
  id: string
  federalTaxId: string
  corporateName: string
  tradingName: string
  invitedName: string
  invitedEmail: string
  invitedPhone: string
  passwordType: string
  accessPermission: string
  password: string
}

const CustomerSchema: JSONSchemaType<ICustomerFormData> = {
  type: 'object',
  properties: {
    federalTaxId: {
      type: 'string',
      minLength: 1,
      pattern: validationPatters.cnpj,
      errorMessage: 'CNPJ Inválido.',
    },
    corporateName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Razão Social é obrigatória.',
    },
    tradingName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Nome Fantasia é obrigatório.',
    },
    invitedName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Nome é obrigatório.',
    },
    invitedEmail: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'Email é obrigatório.',
    },
    invitedPhone: {
      type: 'string',
      minLength: 14,
      errorMessage: 'Telefone é obrigatório.',
    },
    passwordType: {
      type: 'string',
      default: 'createPassword',
    },
    password: {
      type: 'string',
    },
    accessPermission: {
      type: 'string',
      default: 'Proprietário',
    },
    id: {
      type: 'string',
    },
  },
  allOf: [
    {
      if: {
        properties: { passwordType: { const: 'sendPassword' } },
      },
      then: {
        required: ['password'],
        properties: {
          password: {
            type: 'string',
            minLength: 8,
            pattern: validationPatters.password,
            errorMessage: 'Senha é obrigatória.',
          },
        },
      },
    },
  ],
  required: ['federalTaxId', 'corporateName', 'tradingName', 'invitedName', 'invitedEmail', 'invitedPhone'],
  additionalProperties: false,
}

export default CustomerSchema
